export default __webpack_public_path__ + "static/apace_merchants-cc39949740f7ff6675c85d327e6b6da2.mp4";